<template>
  <v-menu offset-y>
    <template #activator="{ on: menu }">
      <v-tooltip bottom>
        <template #activator="{ on: tooltip }">
          <v-btn
            icon
            :loading="loading"
            dark
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon
              color="white"
            >
              mdi-account-key
            </v-icon>
          </v-btn>
        </template>
        <span>Manage Passkeys</span>
      </v-tooltip>
    </template>
    <v-list
      v-if="!loading"
    >
      <v-list-item>
        <v-btn
          color="env"
          dark
          @click="register"
        >
          <v-icon left>
            mdi-key-plus
          </v-icon>
          Register new key
        </v-btn>
      </v-list-item>
      <v-list-item
        v-for="(passkey) in $store.state.user.profile.passkeys"
        :key="passkey.id"
      >
        <v-list-item-icon>
          <v-icon>mdi-key</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          {{ passkey.user_agent }} ({{ passkey.created }})
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            icon
            @click="deleteKey(passkey.id)"
          >
            <v-icon>mdi-key-remove</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import ApiService from '../../utils/api.service';
import { startRegistration } from '@simplewebauthn/browser';
import { USER_ME_REQUEST } from '@/store/actions/user'
import { mapActions } from 'vuex';

export default {
    computed: {
        loading() {
        return !this.$store.getters['user/isProfileLoaded']
        },
        passkeys() {
            return this.$store.user?.profile.passkeys ?? []
        }
    },
    methods: {
        ...mapActions('user', [
            USER_ME_REQUEST
        ]),
        async register() {
            // console.log("Register with token", props?.token?.access_token)
            
            const optionsData = await ApiService.post(`api/v1/auth/register/start`)
            const optionsJSON = optionsData.data
                
            let attResp;
        
            try {
                // Pass the options to the authenticator and wait for a response
                attResp = await startRegistration({ optionsJSON })
            } catch (error) {
                // Some basic error handling
                if (error.name === 'InvalidStateError') {
                    this.$toast.error('Error: Authenticator was probably already registered by user')
                } else {
                    this.$toast.error(error)
                }

                throw error;
            }
            
            console.log(attResp)
            const verificationResp = await ApiService.post(`api/v1/auth/register`, JSON.stringify(attResp), {
                headers:{
                    "Content-Type": 'application/json',
                }
            })

            // Wait for the results of verification
            const verificationJSON = await verificationResp.data;

                // Show UI appropriate for the `verified` status
            if (verificationJSON && verificationJSON.verified) {
                this.$toast.success("Registered")
                this.USER_ME_REQUEST()
            } else {
                this.$toast.error(`Oh no, something went wrong! Response: ${JSON.stringify(
                    verificationJSON
                )}`)
            }
        },
        async deleteKey(id) {
        
            const passkeysData = await ApiService.delete(`api/v1/users/me/keys/${id}`)
            this.$toast.success("Passkey Deleted")
            this.USER_ME_REQUEST()
        }

    }
}
</script>